//src/pages/TeamMember.jsx - This is for individual team member profile pages at /team/:id
// src/pages/TeamMember.jsx - partial update showing just the team data
// ...rest of imports and component code
// src/pages/TeamMember.jsx - Updated with direct S3 URLs
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Mail, Phone, Linkedin, Twitter, Award, BookOpen, Briefcase, FileText } from 'lucide-react';

// Base S3 URL for your bucket
const S3_BASE_URL = 'https://amvlawwebsitefa905-dev.s3.ap-south-1.amazonaws.com';

// Mock team data with detailed profiles and direct S3 URLs
const teamData = {
  'mehak-gupta': {
    name: 'Mehak Gupta',
    position: 'Managing Partner',
    bio: 'Adv. Mehak Gupta is a distinguished and accomplished Advocate with a stellar career spanning over a decade. Her unwavering commitment to upholding justice, coupled with her innate sense of values and passion for truth, has earned her a reputable standing in the legal fraternity.',
    fullBio: [
      'Adv. Mehak Gupta is a distinguished and accomplished Advocate with a stellar career spanning over a decade. Her unwavering commitment to upholding justice, coupled with her innate sense of values and passion for truth, has earned her a reputable standing in the legal fraternity.',
      'Holding a Post graduation and Master\'s degree in Law from BVP, Pune coupled with graduate degree in Arts from Delhi University with specialization in Philosophy and Literature, and triple diplomas in Intellectual Property Rights, Cyber Laws, and Corporate Laws, Ms. Gupta\'s academic credentials are a testament to her scholarly prowess.',
      'Member with the Bar Council of India and the Bar Council of Delhi, Ms. Gupta\'s expertise lies in Civil, Commercial & Matrimonial litigation and legal consultation & strategizing. Her extensive experience in navigating complex legal landscapes has equipped her with a unique ability to provide astute counsel and strategic guidance.',
      'A staunch advocate for women\'s rights, Ms. Gupta has been instrumental in promoting awareness and sensitization about Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013.'
    ],
    email: 'mehakgupta@amvlaw.io',
    phone: '9990358009',
    linkedin: 'www.linkedin.com/in/mehakguptaamvlaw',
    image: `${S3_BASE_URL}/assets/images/team/mehak-gupta.jpeg`,
    education: [
      { degree: "Post Graduate and Master's degree in Law", institution: "BVP, Pune", year: "" },
      { degree: "BA, Philosophy and Literature", institution: "Delhi University", year: "" },
      { degree: "Diploma in Intellectual Property Rights", institution: "", year: "" },
      { degree: "Diploma in Cyber Laws", institution: "", year: "" },
      { degree: "Diploma in Corporate Laws", institution: "", year: "" }
    ],
    expertise: [
      "Civil Litigation",
      "Commercial Litigation",
      "Matrimonial Law",
      "Legal Consultation & Strategizing",
      "Sexual Harassment of Women at Workplace (POSH) Act, 2013"
    ],
    barCouncil: "Bar Council of Delhi and Bar Council of India",
    poshExpertise: [
      "Designing and conducting training programs to foster a safe and informed work environment",
      "Drafting and curating internal company policies for handling and resolving complaints under the POSH Act",
      "Conducting workshops to educate individuals about women's safety and rights under the POSH Act",
      "Serving as an independent member on Internal Complaints Committees to investigate and adjudicate complaints"
    ],
    courts: [
      "Supreme Court of India",
      "Delhi High Court",
      "District Courts in Delhi NCR"
    ],
    languages: ["English", "Hindi"]
  },
  'vibhor-gupta': {
    name: 'Vibhor Gupta',
    position: 'Managing Partner',
    bio: 'Adv. Vibhor Gupta, an alumnus of Campus Law Centre, Delhi University (CLC, DU), is a go-to litigator and strategist specializing in White-Collar Crimes, Criminal Defense, and Property Law. With expertise in trial strategy, cross-examination, and bails, he provides comprehensive legal defense for the accused in cases led by CBI, ED, SFIO, and GST authorities.',
    fullBio: ['Adv. Vibhor Gupta, an alumnus of Campus Law Centre, Delhi University (CLC, DU), is a go-to litigator and strategist specializing in White-Collar Crimes, Criminal Defense, and Property Law. With expertise in trial strategy, cross-examination, and bails, he provides comprehensive legal defense for the accused in cases led by CBI, ED, SFIO, and GST authorities. Known for his precision in legal strategy and courtroom advocacy, he ensures robust defense in high-stakes matters while upholding the principles of justice and due process.',
  'A pioneer in legal technology, leading the integration of AI into legal practice through custom research tools and predictive analytics that enhance case preparation and forecasting. He advocates for ethical AI development to advance access to justice and improve case management efficiency.',
  'A staunch advocate for justice and due process, he blends traditional legal principles with modern investigative techniques to craft precise, persuasive arguments. His leadership and mentorship foster a culture of excellence and integrity at the firm, ensuring unwavering commitment to client advocacy and the pursuit of legal excellence.'
      
    ],
    email: 'vibhorgupta@amvlaw.io',
    phone: '9910508654',
    linkedin: 'www.linkedin.com/in/vibhorguptaamvlaw',
    image: `${S3_BASE_URL}/assets/images/team/vibhor-gupta.jpeg`,
    education: [
      { degree: "LLB", institution: "Campus Law Centre, Delhi University", year: "" }
    ],
    expertise: [
      "White-Collar Crimes",
      "Criminal Defense",
      "Property Law",
      "Trial Strategy",
      "Cross-examination",
      "Bail Matters",
      "Defense in CBI, ED, SFIO, and GST cases"
    ],
    barCouncil: "Bar Council of Delhi",
    courts: [
      "Supreme Court of India",
      "Delhi High Court",
      "Special Courts (CBI, ED, SFIO)",
      "District Courts"
    ],
    languages: ["English", "Hindi"]
  },
  'vikas-sharma': {
    name: 'Vikas Sharma',
    position: 'Legal Consultant',
    bio: 'Adv. Vikas Sharma, originally from Allahabad, began his career as a Customs Officer in Mumbai, gaining firsthand insight into the complexities of customs regulations and enforcement. Driven by a passion for justice, he transitioned into law, bringing his in-depth regulatory knowledge and enforcement experience to the courtroom.',
    fullBio: [
      'Adv. Vikas Sharma, originally from Allahabad, began his career as a Customs Officer in Mumbai, gaining firsthand insight into the complexities of customs regulations and enforcement. Driven by a passion for justice, he transitioned into law, bringing his in-depth regulatory knowledge and enforcement experience to the courtroom.',
      'Now a distinguished Supreme Court advocate, he specializes in Customs Law and International Trade Regulations, representing clients in high-stakes disputes involving customs duties, trade compliance, smuggling allegations, and enforcement actions. His unique background allows him to craft strategic defenses and advisory solutions, ensuring businesses and individuals navigate the complexities of customs litigation with confidence.',
      'Known for his meticulous legal analysis and persuasive advocacy, Adv. Sharma stands as a trusted authority in Customs Law, offering expert representation at the Supreme Court of India and other appellate forums.'
    ],
    email: 'info@amvlaw.io',
    phone: '',
    image: `${S3_BASE_URL}/assets/images/team/vikas-sharma.jpeg`,
    education: [
      { degree: "Former Customs Officer", institution: "Mumbai", year: "" }
    ],
    expertise: [
      "Customs Law",
      "International Trade Regulations",
      "Customs Duties",
      "Trade Compliance",
      "Smuggling Allegations",
      "Enforcement Actions"
    ],
    courts: [
      "Supreme Court of India",
      "Appellate Forums"
    ],
    languages: ["English", "Hindi"]
  },
  'eram-afrin': {
    name: 'Eram Afrin',
    position: 'Associate',
    bio: 'Adv. Eram Afrin is a dedicated and detail-oriented Associate at AVM Law, bringing fresh perspectives and a keen analytical approach to legal practice. As a young advocate, she is committed to mastering the intricacies of litigation and corporate law while contributing to the firm\'s dynamic legal strategies.',
    fullBio: [
      'Adv. Eram Afrin is a dedicated and detail-oriented Associate at AVM Law, bringing fresh perspectives and a keen analytical approach to legal practice. As a young advocate, she is committed to mastering the intricacies of litigation and corporate law while contributing to the firm\'s dynamic legal strategies.',
      'With a strong academic foundation and a passion for legal research, drafting, and client advocacy, she assists in case preparation, statutory compliance, and courtroom proceedings. Her enthusiasm for learning and precision in legal analysis make her a valuable asset to the firm.',
      'Eram is focused on building expertise in litigation, contract law, and dispute resolution, ensuring diligent representation and unwavering commitment to client success.'
    ],
    email: 'info@amvlaw.io',
    phone: '',
    image: `${S3_BASE_URL}/assets/images/team/eram-afrin.jpeg`,
    education: [
      { degree: "Law Degree", institution: "", year: "" }
    ],
    expertise: [
      "Litigation",
      "Corporate Law",
      "Legal Research",
      "Contract Law",
      "Dispute Resolution"
    ],
    languages: ["English", "Hindi"]
  },
  'akshay-dalal': {
    name: 'Akshay Dalal',
    position: 'Associate',
    bio: 'Adv. Akshay is a dynamic and detail-oriented Associate at AVM Law, with a strong focus on Criminal Law. Passionate about criminal defense and trial advocacy, he is dedicated to understanding the complexities of the legal system while ensuring justice for his clients.',
    fullBio: [
      'Adv. Akshay is a dynamic and detail-oriented Associate at AVM Law, with a strong focus on Criminal Law. Passionate about criminal defense and trial advocacy, he is dedicated to understanding the complexities of the legal system while ensuring justice for his clients.',
      'With a keen interest in legal research, case strategy, and courtroom representation, he actively assists in drafting petitions, analyzing evidence, and preparing defense arguments. His commitment to due process and client rights makes him a valuable contributor to the firm\'s criminal litigation practice.',
      'Akshay is driven to refine his expertise in criminal trials, bail matters, and appellate advocacy, striving to uphold the highest standards of legal excellence and ethical defense.'
    ],
    email: 'info@amvlaw.io',
    phone: '',
    image: `${S3_BASE_URL}/assets/images/team/akshay-dalal.jpeg`,
    education: [
      { degree: "Law Degree", institution: "", year: "" }
    ],
    expertise: [
      "Criminal Law",
      "Criminal Defense",
      "Trial Advocacy",
      "Legal Research",
      "Case Strategy",
      "Bail Matters",
      "Appellate Advocacy"
    ],
    languages: ["English", "Hindi"]
  }
};

const TeamMember = () => {
  const { id } = useParams();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Simulate API fetch
    setTimeout(() => {
      if (teamData[id]) {
        setMember(teamData[id]);
      }
      setLoading(false);
    }, 300); // Simulate network delay
  }, [id]);
  
  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-secondary"></div>
      </div>
    );
  }
  
  if (!member) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Team Member Not Found</h1>
        <p className="text-gray-600 mb-6">The team member you are looking for does not exist or has been removed.</p>
        <Link to="/team" className="text-secondary hover:text-secondary-dark flex items-center">
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to Team
        </Link>
      </div>
    );
  }
  
  return (
    <div className="bg-white min-h-screen">
      {/* Header Section */}
      <div className="bg-primary text-white py-16">
        <div className="container mx-auto px-4">
          <Link to="/team" className="inline-flex items-center text-white/80 hover:text-white mb-6">
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back to Team
          </Link>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
            <div className="md:col-span-1">
              <div className="w-48 h-48 rounded-full overflow-hidden mx-auto bg-gradient-to-r from-primary-dark to-primary">
                <img 
                  src={member.image}
                  alt={member.name} 
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = `<span class="text-white text-8xl flex items-center justify-center h-full">${member.name.charAt(0)}</span>`;
                  }}
                />
              </div>
            </div>
            
            <div className="md:col-span-2">
              <h1 className="text-3xl md:text-4xl font-bold mb-2">{member.name}</h1>
              <p className="text-xl text-white/80 mb-4">{member.position}</p>
              
              <div className="flex flex-wrap gap-6 mb-6">
                {member.email && (
                  <a 
                    href={`mailto:${member.email}`}
                    className="flex items-center text-white/90 hover:text-white"
                  >
                    <Mail className="h-5 w-5 mr-1" />
                    <span>{member.email}</span>
                  </a>
                )}
                
                {member.phone && (
                  <a 
                    href={`tel:${member.phone}`}
                    className="flex items-center text-white/90 hover:text-white"
                  >
                    <Phone className="h-5 w-5 mr-1" />
                    <span>{member.phone}</span>
                  </a>
                )}
                
                {member.linkedin && (
                  <a 
                    href={member.linkedin.startsWith('http') ? member.linkedin : `https://${member.linkedin}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-white/90 hover:text-white"
                  >
                    <Linkedin className="h-5 w-5 mr-1" />
                    <span>LinkedIn</span>
                  </a>
                )}
              </div>
              
              <p className="text-lg text-white/90">{member.bio}</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Full Bio Section */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold text-primary mb-6">About {member.name}</h2>
            
            <div className="prose prose-lg max-w-none">
              {member.fullBio?.map((paragraph, index) => (
                <p key={index} className="mb-4 text-gray-700">{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </section>
      
      {/* Expertise & Education Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {/* Expertise */}
              <div>
                <div className="flex items-center mb-6">
                  <Briefcase className="h-6 w-6 text-secondary mr-3" />
                  <h2 className="text-2xl font-bold text-primary">Areas of Expertise</h2>
                </div>
                
                <ul className="space-y-3">
                  {member.expertise?.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="bg-secondary/10 text-secondary p-1 rounded-full mr-3 mt-1">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      </span>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              {/* Education */}
              <div>
                <div className="flex items-center mb-6">
                  <BookOpen className="h-6 w-6 text-secondary mr-3" />
                  <h2 className="text-2xl font-bold text-primary">Education & Certifications</h2>
                </div>
                
                <ul className="space-y-6">
                  {member.education?.map((edu, index) => (
                    <li key={index} className="border-l-2 border-secondary/20 pl-4 pb-2">
                      <h3 className="font-bold text-gray-900">{edu.degree}</h3>
                      {edu.institution && <p className="text-gray-600">{edu.institution}</p>}
                      {edu.year && <p className="text-gray-500 text-sm">{edu.year}</p>}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Additional Credentials */}
      {(member.courts || member.languages || member.barCouncil || member.poshExpertise) && (
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl font-bold text-primary mb-8">Additional Credentials</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Bar Council & Court Practice */}
                <div>
                  {member.barCouncil && (
                    <div className="mb-6">
                      <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                        <Award className="h-5 w-5 text-secondary mr-2" />
                        Bar Council Membership
                      </h3>
                      <p className="text-gray-700">{member.barCouncil}</p>
                    </div>
                  )}
                  
                  {member.courts && member.courts.length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                        <FileText className="h-5 w-5 text-secondary mr-2" />
                        Court Practice
                      </h3>
                      <ul className="list-disc list-inside text-gray-700">
                        {member.courts.map((court, index) => (
                          <li key={index}>{court}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                
                {/* Languages & Special Expertise */}
                <div>
                  {member.languages && member.languages.length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-lg font-bold text-gray-900 mb-3">Languages</h3>
                      <p className="text-gray-700">{member.languages.join(', ')}</p>
                    </div>
                  )}
                  
                  {member.poshExpertise && member.poshExpertise.length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-lg font-bold text-gray-900 mb-3">POSH Expertise</h3>
                      <ul className="list-disc list-inside text-gray-700">
                        {member.poshExpertise.map((expertise, index) => (
                          <li key={index}>{expertise}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      
      {/* Contact Section */}
      <section className="py-12 bg-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold mb-6">Connect with {member.name}</h2>
          <p className="mb-8 max-w-2xl mx-auto">
            Interested in consulting with {member.name.split(' ')[0]} about your legal matters? 
            Contact us to schedule a consultation.
          </p>
          
          <Link
            to="/contact"
            className="inline-block bg-accent hover:bg-accent-dark text-white px-6 py-3 rounded-md font-medium transition-colors"
          >
            Schedule a Consultation
          </Link>
        </div>
      </section>
    </div>
  );
};

export default TeamMember;